import React from 'react';
import { 
  Header, 
  About, 
  DownloadSection, 
  ScreenshotsSection, 
  FAQ, 
  StatsCounter 
} from '../features/landing';

/**
 * HomePage Component
 * 
 * Main landing page that displays all the key sections of the municipality app website.
 * This component serves as a container for all landing page features and follows
 * the page-level component pattern for better separation of concerns.
 * 
 * Features included:
 * - Hero header with app introduction
 * - About section with app description
 * - Statistics counter showing app usage
 * - Screenshots showcase
 * - Download section with app store links
 * - Frequently asked questions
 * 
 * @component
 * @example
 * return (
 *   <HomePage />
 * )
 */
export default function HomePage() {
  return (
    <>
      {/* Hero section with main app introduction */}
      <Header />
      
      {/* App description and features overview */}
      <About />
      
      {/* Statistics showcasing app usage and impact */}
      {/* <StatsCounter /> */}
      
      {/* Visual showcase of app screens and features */}
      <ScreenshotsSection />
      
      {/* Download links and app store badges */}
      <DownloadSection />
      
      {/* Common questions and answers about the app */}
      <FAQ />
    </>
  );
}